export const languages = [
  {
    id: "javascript",
    name: "JavaScript",
    extension: ".js",
    monacoLanguage: "javascript",
  },
  {
    id: "typescript",
    name: "TypeScript",
    extension: ".ts",
    monacoLanguage: "typescript",
  },
  {
    id: "python",
    name: "Python",
    extension: ".py",
    monacoLanguage: "python",
  },
  {
    id: "html",
    name: "HTML",
    extension: ".html",
    monacoLanguage: "html",
  },
  {
    id: "json",
    name: "JSON",
    extension: ".json",
    monacoLanguage: "json",
  },
];
